// frontend/src/utils/i18nLabels.js
// =============================================================================
// Translation helpers for backend technical codes.
// =============================================================================

export function statusLabel(t, status) {
  const key = String(status || "").trim();
  if (!key) return "—";
  return t(`common:status.${key}`, { defaultValue: key });
}

export function exceptionReasonLabel(t, reason) {
  const key = String(reason || "").trim();
  if (!key) return "—";
  return t(`serviceConsumption:reasons.${key}`, { defaultValue: key });
}

export function movementTypeLabel(t, movementType) {
  const key = String(movementType || "").trim();
  if (!key) return "—";
  return t(`stock:actions.${key}`, { defaultValue: key });
}
